import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';

// Official EVE SSO button asset published by CCP for third-party applications
const SSO_BUTTON_SRC =
  'https://web.ccpgamescdn.com/eveonlineassets/developers/eve-sso-login-black-large.png';

function Login() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    const errorParam = searchParams.get('error');
    const messageParam = searchParams.get('message');

    if (errorParam) {
      let errorMessage = 'An error occurred during login.';

      switch (errorParam) {
        case 'invalid_state':
          errorMessage =
            'Security validation failed. This might happen if you took too long to complete the CAPTCHA. Please try again.';
          break;
        case 'no_code':
          errorMessage = 'No authorization code received from EVE Online. Please try again.';
          break;
        case 'oauth_error':
          errorMessage = messageParam || 'OAuth error from EVE Online. Please try again.';
          break;
        case 'session_error':
          errorMessage = 'Session error. Please ensure cookies are enabled and try again.';
          break;
        case 'auth_failed':
          errorMessage = 'Authentication failed. Please try again.';
          break;
        case 'session_expired':
          errorMessage = 'Your session has expired. Please log in again to continue.';
          break;
        default:
          errorMessage = messageParam || 'An unknown error occurred. Please try again.';
      }

      setError(errorMessage);

      // Clear URL parameters after showing error
      setTimeout(() => {
        setSearchParams({});
      }, 100);
    }
  }, [searchParams, setSearchParams]);

  const handleLogin = () => {
    setError(null);
    authService.login();
  };

  return (
    <>
      <div className="bg-field with-stars" />

      <main className="login-min">
        <div className="login-card">
          <div className="mark">
            <div className="brand-mark" />
            <span>EVEORG</span>
          </div>

          <span className="status-pill">
            <span className="dot" />
            ESI · Nominal
          </span>

          <h1>
            MANAGE YOUR CORP
            <br />
            <span className="accent">IN EVE ONLINE</span>
          </h1>

          <p className="tag">
            Sign in with your EVE Online account to bind treasury, structures, assets and roster.
          </p>

          {error && (
            <div className="login-error">
              <div className="hdr">▲ Authentication Error</div>
              {error}
            </div>
          )}

          <button
            className="sso-btn"
            type="button"
            aria-label="Log in with EVE Online"
            onClick={handleLogin}
          >
            {imgFailed ? (
              <span className="sso-fallback">LOG IN with EVE Online</span>
            ) : (
              <img
                src={SSO_BUTTON_SRC}
                alt="Log in with EVE Online"
                width="270"
                height="45"
                onError={() => setImgFailed(true)}
              />
            )}
          </button>

          <div className="login-divider" />

          <div className="foot">
            EVE Online · CCP hf. · Third-party tool · Not affiliated with CCP Games
            <br />
            <a href="#">Privacy</a> &nbsp;·&nbsp; <a href="#">Scopes</a> &nbsp;·&nbsp;{' '}
            <a href="#">Help</a>
          </div>
        </div>
      </main>
    </>
  );
}

export default Login;
